import { create } from "zustand";
import { persist } from "zustand/middleware";
import i18n from "@lib/i18n/i18n";
import { applyDocumentLanguage } from "@lib/i18n/document";
import { normalizeLanguage, type LanguageCode } from "@lib/i18n/languages";
import { TENANT_LANGUAGE_STORE_LS_KEY } from "@lib/tenantPersistKeys";

interface LanguageStore {
    language: LanguageCode;
    setLanguage: (code: unknown) => void;
}

export const useLanguageStore = create<LanguageStore>()(
    persist(
        (set) => ({
            language: normalizeLanguage(i18n.language),
            setLanguage: (code) => {
                const next = normalizeLanguage(code);
                void i18n.changeLanguage(next);
                applyDocumentLanguage(next);
                set({ language: next });
            },
        }),
        {
            name: TENANT_LANGUAGE_STORE_LS_KEY,
            partialize: (s) => ({ language: s.language }),
            onRehydrateStorage: () => (state) => {
                if (!state) return;
                const next = normalizeLanguage(state.language);
                if (i18n.language !== next) void i18n.changeLanguage(next);
                applyDocumentLanguage(next);
            },
        }
    )
);

/** Language for non-React code (formatters). */
export function getCurrentLanguage(): LanguageCode {
    return useLanguageStore.getState().language;
}
